import styled from "styled-components";

export const StyledChatMessage = styled.div<{
  $isLast?: boolean;
}>`
  margin-bottom: ${({ $isLast }) => $isLast ? 'var(--spacing-sm)' : 'var(--spacing-lg)'};
  h5 {
    font-size: var(--font-size-md);
    font-weight: 600;
    margin-bottom: var(--spacing-xs);
    color: var(--color-text);
    margin-top: 0;
    span {
      font-size: var(--font-size-sm);
      color: var(--color-text-80);
      font-weight: 400;
    }
  }
  p {
    font-size: var(--font-size-sm);
    color: var(--color-text);
    word-break: break-word;
  }
`;
